import React, { useState } from 'react';
import { apiService } from '../services/api';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px 40px',
    background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a3a 100%)',
  },
  card: {
    maxWidth: '520px',
    width: '100%',
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '16px',
    padding: '2.5rem',
    color: '#e5e7eb',
  },
  heading: {
    color: '#fff',
    marginBottom: '0.75rem',
  },
  description: {
    color: '#9ca3af',
    lineHeight: 1.6,
    marginBottom: '1.5rem',
  },
  button: {
    display: 'inline-block',
    padding: '0.75rem 1.5rem',
    borderRadius: '8px',
    border: 'none',
    background: '#8b5cf6',
    color: '#fff',
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: '1rem',
    marginBottom: '2rem',
  },
  error: {
    color: '#ef4444',
    marginBottom: '1rem',
  },
  stepsHeading: {
    color: '#fff',
    marginBottom: '0.75rem',
  },
  steps: {
    color: '#d1d5db',
    lineHeight: 1.8,
    paddingLeft: '1.25rem',
  },
};

const DownloadExtensionPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    setLoading(true);
    setError(null);
    try {
      const url = await apiService.getPromptBuilderDownloadUrl();
      window.location.href = url;
    } catch (err) {
      setError('Could not fetch the download link. Please try again or contact the team.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.heading}>AI Prompt Builder Extension</h1>
        <p style={styles.description}>
          A Chrome extension with two tools: search adda247 faculty by ID or name to pull
          up their photo and details (with a one-click Copy Image), and an image resizer
          that shows a ready-made AI image prompt for any thumbnail size — insert it
          directly into ChatGPT or copy it for any other AI tool.
        </p>

        {error && <p style={styles.error}>{error}</p>}

        <button style={styles.button} onClick={handleDownload} disabled={loading}>
          {loading ? 'Preparing download…' : 'Download Extension'}
        </button>

        <h2 style={styles.stepsHeading}>Install steps</h2>
        <ol style={styles.steps}>
          <li>Download the zip, then double-click it to unzip — this creates a new folder next to it</li>
          <li>Go to chrome://extensions</li>
          <li>Enable Developer mode (top right)</li>
          <li>Click "Load unpacked" and select that unzipped folder (not the .zip file itself)</li>
        </ol>
      </div>
    </div>
  );
};

export default DownloadExtensionPage;
